/**
 * @generated SignedSource<<a0ae29adccda2914ce3e588400023147>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackCastPanelFragment$data = {
  readonly number: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProposalFeedbackSummaryFragment">;
  readonly " $fragmentType": "FeedbackCastPanelFragment";
};
export type FeedbackCastPanelFragment$key = {
  readonly " $data"?: FeedbackCastPanelFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCastPanelFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackCastPanelFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProposalFeedbackSummaryFragment"
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};

(node as any).hash = "73866c0b96a312ff36e86f29decdf0c3";

export default node;
